export const blockIconsSearchFlatware = (
	<span className='material-symbols-outlined'>flatware</span>
);
